<p>closed-cases-list works!</p>
